var map = {
	"./add.svg": "./app/javascript/assets/frontend/ico/add.svg",
	"./arrow_left.svg": "./app/javascript/assets/frontend/ico/arrow_left.svg",
	"./arrow_right.svg": "./app/javascript/assets/frontend/ico/arrow_right.svg",
	"./arrow_top.svg": "./app/javascript/assets/frontend/ico/arrow_top.svg",
	"./back.svg": "./app/javascript/assets/frontend/ico/back.svg",
	"./bag.svg": "./app/javascript/assets/frontend/ico/bag.svg",
	"./ball.svg": "./app/javascript/assets/frontend/ico/ball.svg",
	"./ball_left.svg": "./app/javascript/assets/frontend/ico/ball_left.svg",
	"./bar.svg": "./app/javascript/assets/frontend/ico/bar.svg",
	"./bear.svg": "./app/javascript/assets/frontend/ico/bear.svg",
	"./bear_large.svg": "./app/javascript/assets/frontend/ico/bear_large.svg",
	"./bear_small.svg": "./app/javascript/assets/frontend/ico/bear_small.svg",
	"./blob.svg": "./app/javascript/assets/frontend/ico/blob.svg",
	"./blob_large.svg": "./app/javascript/assets/frontend/ico/blob_large.svg",
	"./blob_small.svg": "./app/javascript/assets/frontend/ico/blob_small.svg",
	"./book.svg": "./app/javascript/assets/frontend/ico/book.svg",
	"./book_large.svg": "./app/javascript/assets/frontend/ico/book_large.svg",
	"./book_small.svg": "./app/javascript/assets/frontend/ico/book_small.svg",
	"./calendar_left.svg": "./app/javascript/assets/frontend/ico/calendar_left.svg",
	"./calendar_right.svg": "./app/javascript/assets/frontend/ico/calendar_right.svg",
	"./caret_down.svg": "./app/javascript/assets/frontend/ico/caret_down.svg",
	"./cart.svg": "./app/javascript/assets/frontend/ico/cart.svg",
	"./check_circle.svg": "./app/javascript/assets/frontend/ico/check_circle.svg",
	"./checkbox_act.svg": "./app/javascript/assets/frontend/ico/checkbox_act.svg",
	"./checkbox_empty.svg": "./app/javascript/assets/frontend/ico/checkbox_empty.svg",
	"./checked.svg": "./app/javascript/assets/frontend/ico/checked.svg",
	"./chevron_down.svg": "./app/javascript/assets/frontend/ico/chevron_down.svg",
	"./chevron_left.svg": "./app/javascript/assets/frontend/ico/chevron_left.svg",
	"./chevron_right.svg": "./app/javascript/assets/frontend/ico/chevron_right.svg",
	"./chevron_top.svg": "./app/javascript/assets/frontend/ico/chevron_top.svg",
	"./clipboard.svg": "./app/javascript/assets/frontend/ico/clipboard.svg",
	"./contacts_location.svg": "./app/javascript/assets/frontend/ico/contacts_location.svg",
	"./contacts_phone.svg": "./app/javascript/assets/frontend/ico/contacts_phone.svg",
	"./contacts_user.svg": "./app/javascript/assets/frontend/ico/contacts_user.svg",
	"./copy.svg": "./app/javascript/assets/frontend/ico/copy.svg",
	"./cross.svg": "./app/javascript/assets/frontend/ico/cross.svg",
	"./cursor.svg": "./app/javascript/assets/frontend/ico/cursor.svg",
	"./dashboard.svg": "./app/javascript/assets/frontend/ico/dashboard.svg",
	"./dashboard_large.svg": "./app/javascript/assets/frontend/ico/dashboard_large.svg",
	"./delete.svg": "./app/javascript/assets/frontend/ico/delete.svg",
	"./dropdown.svg": "./app/javascript/assets/frontend/ico/dropdown.svg",
	"./empty-list.svg": "./app/javascript/assets/frontend/ico/empty-list.svg",
	"./export.svg": "./app/javascript/assets/frontend/ico/export.svg",
	"./eye.svg": "./app/javascript/assets/frontend/ico/eye.svg",
	"./eye_slash.svg": "./app/javascript/assets/frontend/ico/eye_slash.svg",
	"./facebook.svg": "./app/javascript/assets/frontend/ico/facebook.svg",
	"./fly.svg": "./app/javascript/assets/frontend/ico/fly.svg",
	"./footer_fb.svg": "./app/javascript/assets/frontend/ico/footer_fb.svg",
	"./footer_gp.svg": "./app/javascript/assets/frontend/ico/footer_gp.svg",
	"./footer_lang_dd.svg": "./app/javascript/assets/frontend/ico/footer_lang_dd.svg",
	"./footer_tw.svg": "./app/javascript/assets/frontend/ico/footer_tw.svg",
	"./form_mail.svg": "./app/javascript/assets/frontend/ico/form_mail.svg",
	"./form_pass.svg": "./app/javascript/assets/frontend/ico/form_pass.svg",
	"./gift-square.svg": "./app/javascript/assets/frontend/ico/gift-square.svg",
	"./gift.svg": "./app/javascript/assets/frontend/ico/gift.svg",
	"./gmail.svg": "./app/javascript/assets/frontend/ico/gmail.svg",
	"./hourglass.svg": "./app/javascript/assets/frontend/ico/hourglass.svg",
	"./info.svg": "./app/javascript/assets/frontend/ico/info.svg",
	"./info_redesign.svg": "./app/javascript/assets/frontend/ico/info_redesign.svg",
	"./instagram.svg": "./app/javascript/assets/frontend/ico/instagram.svg",
	"./lang.svg": "./app/javascript/assets/frontend/ico/lang.svg",
	"./link_highlight_bottom.svg": "./app/javascript/assets/frontend/ico/link_highlight_bottom.svg",
	"./link_highlight_top.svg": "./app/javascript/assets/frontend/ico/link_highlight_top.svg",
	"./linkedin.svg": "./app/javascript/assets/frontend/ico/linkedin.svg",
	"./list.svg": "./app/javascript/assets/frontend/ico/list.svg",
	"./locale.svg": "./app/javascript/assets/frontend/ico/locale.svg",
	"./location.svg": "./app/javascript/assets/frontend/ico/location.svg",
	"./lock.svg": "./app/javascript/assets/frontend/ico/lock.svg",
	"./logout.svg": "./app/javascript/assets/frontend/ico/logout.svg",
	"./map_search.svg": "./app/javascript/assets/frontend/ico/map_search.svg",
	"./messenger.svg": "./app/javascript/assets/frontend/ico/messenger.svg",
	"./mymir.svg": "./app/javascript/assets/frontend/ico/mymir.svg",
	"./pencil.svg": "./app/javascript/assets/frontend/ico/pencil.svg",
	"./photo.svg": "./app/javascript/assets/frontend/ico/photo.svg",
	"./photo_large.svg": "./app/javascript/assets/frontend/ico/photo_large.svg",
	"./plus.svg": "./app/javascript/assets/frontend/ico/plus.svg",
	"./pomade.svg": "./app/javascript/assets/frontend/ico/pomade.svg",
	"./pomade_left.svg": "./app/javascript/assets/frontend/ico/pomade_left.svg",
	"./popup_close.svg": "./app/javascript/assets/frontend/ico/popup_close.svg",
	"./print.svg": "./app/javascript/assets/frontend/ico/print.svg",
	"./profile_nav_balance.svg": "./app/javascript/assets/frontend/ico/profile_nav_balance.svg",
	"./profile_nav_list.svg": "./app/javascript/assets/frontend/ico/profile_nav_list.svg",
	"./profile_nav_products.svg": "./app/javascript/assets/frontend/ico/profile_nav_products.svg",
	"./profile_nav_settings.svg": "./app/javascript/assets/frontend/ico/profile_nav_settings.svg",
	"./question.svg": "./app/javascript/assets/frontend/ico/question.svg",
	"./refresh.svg": "./app/javascript/assets/frontend/ico/refresh.svg",
	"./reload.svg": "./app/javascript/assets/frontend/ico/reload.svg",
	"./remove.svg": "./app/javascript/assets/frontend/ico/remove.svg",
	"./request-send.svg": "./app/javascript/assets/frontend/ico/request-send.svg",
	"./reviews_arrow.svg": "./app/javascript/assets/frontend/ico/reviews_arrow.svg",
	"./rose.svg": "./app/javascript/assets/frontend/ico/rose.svg",
	"./rose_medium.svg": "./app/javascript/assets/frontend/ico/rose_medium.svg",
	"./rose_small.svg": "./app/javascript/assets/frontend/ico/rose_small.svg",
	"./save.svg": "./app/javascript/assets/frontend/ico/save.svg",
	"./search.svg": "./app/javascript/assets/frontend/ico/search.svg",
	"./settings.svg": "./app/javascript/assets/frontend/ico/settings.svg",
	"./share.svg": "./app/javascript/assets/frontend/ico/share.svg",
	"./sign_in_profile.svg": "./app/javascript/assets/frontend/ico/sign_in_profile.svg",
	"./skype.svg": "./app/javascript/assets/frontend/ico/skype.svg",
	"./star.svg": "./app/javascript/assets/frontend/ico/star.svg",
	"./step_cash.svg": "./app/javascript/assets/frontend/ico/step_cash.svg",
	"./step_gift.svg": "./app/javascript/assets/frontend/ico/step_gift.svg",
	"./step_payment.svg": "./app/javascript/assets/frontend/ico/step_payment.svg",
	"./step_processing.svg": "./app/javascript/assets/frontend/ico/step_processing.svg",
	"./step_transfer.svg": "./app/javascript/assets/frontend/ico/step_transfer.svg",
	"./telegram.svg": "./app/javascript/assets/frontend/ico/telegram.svg",
	"./trash.svg": "./app/javascript/assets/frontend/ico/trash.svg",
	"./twitter.svg": "./app/javascript/assets/frontend/ico/twitter.svg",
	"./upload.svg": "./app/javascript/assets/frontend/ico/upload.svg",
	"./upload_path.svg": "./app/javascript/assets/frontend/ico/upload_path.svg",
	"./upload_redesign.svg": "./app/javascript/assets/frontend/ico/upload_redesign.svg",
	"./usage_star.svg": "./app/javascript/assets/frontend/ico/usage_star.svg",
	"./viber.svg": "./app/javascript/assets/frontend/ico/viber.svg",
	"./vk.svg": "./app/javascript/assets/frontend/ico/vk.svg",
	"./warning.svg": "./app/javascript/assets/frontend/ico/warning.svg",
	"./whatsapp.svg": "./app/javascript/assets/frontend/ico/whatsapp.svg",
	"./yougiver.svg": "./app/javascript/assets/frontend/ico/yougiver.svg",
	"assets/frontend/ico/add.svg": "./app/javascript/assets/frontend/ico/add.svg",
	"assets/frontend/ico/arrow_left.svg": "./app/javascript/assets/frontend/ico/arrow_left.svg",
	"assets/frontend/ico/arrow_right.svg": "./app/javascript/assets/frontend/ico/arrow_right.svg",
	"assets/frontend/ico/arrow_top.svg": "./app/javascript/assets/frontend/ico/arrow_top.svg",
	"assets/frontend/ico/back.svg": "./app/javascript/assets/frontend/ico/back.svg",
	"assets/frontend/ico/bag.svg": "./app/javascript/assets/frontend/ico/bag.svg",
	"assets/frontend/ico/ball.svg": "./app/javascript/assets/frontend/ico/ball.svg",
	"assets/frontend/ico/ball_left.svg": "./app/javascript/assets/frontend/ico/ball_left.svg",
	"assets/frontend/ico/bar.svg": "./app/javascript/assets/frontend/ico/bar.svg",
	"assets/frontend/ico/bear.svg": "./app/javascript/assets/frontend/ico/bear.svg",
	"assets/frontend/ico/bear_large.svg": "./app/javascript/assets/frontend/ico/bear_large.svg",
	"assets/frontend/ico/bear_small.svg": "./app/javascript/assets/frontend/ico/bear_small.svg",
	"assets/frontend/ico/blob.svg": "./app/javascript/assets/frontend/ico/blob.svg",
	"assets/frontend/ico/blob_large.svg": "./app/javascript/assets/frontend/ico/blob_large.svg",
	"assets/frontend/ico/blob_small.svg": "./app/javascript/assets/frontend/ico/blob_small.svg",
	"assets/frontend/ico/book.svg": "./app/javascript/assets/frontend/ico/book.svg",
	"assets/frontend/ico/book_large.svg": "./app/javascript/assets/frontend/ico/book_large.svg",
	"assets/frontend/ico/book_small.svg": "./app/javascript/assets/frontend/ico/book_small.svg",
	"assets/frontend/ico/calendar_left.svg": "./app/javascript/assets/frontend/ico/calendar_left.svg",
	"assets/frontend/ico/calendar_right.svg": "./app/javascript/assets/frontend/ico/calendar_right.svg",
	"assets/frontend/ico/caret_down.svg": "./app/javascript/assets/frontend/ico/caret_down.svg",
	"assets/frontend/ico/cart.svg": "./app/javascript/assets/frontend/ico/cart.svg",
	"assets/frontend/ico/check_circle.svg": "./app/javascript/assets/frontend/ico/check_circle.svg",
	"assets/frontend/ico/checkbox_act.svg": "./app/javascript/assets/frontend/ico/checkbox_act.svg",
	"assets/frontend/ico/checkbox_empty.svg": "./app/javascript/assets/frontend/ico/checkbox_empty.svg",
	"assets/frontend/ico/checked.svg": "./app/javascript/assets/frontend/ico/checked.svg",
	"assets/frontend/ico/chevron_down.svg": "./app/javascript/assets/frontend/ico/chevron_down.svg",
	"assets/frontend/ico/chevron_left.svg": "./app/javascript/assets/frontend/ico/chevron_left.svg",
	"assets/frontend/ico/chevron_right.svg": "./app/javascript/assets/frontend/ico/chevron_right.svg",
	"assets/frontend/ico/chevron_top.svg": "./app/javascript/assets/frontend/ico/chevron_top.svg",
	"assets/frontend/ico/clipboard.svg": "./app/javascript/assets/frontend/ico/clipboard.svg",
	"assets/frontend/ico/contacts_location.svg": "./app/javascript/assets/frontend/ico/contacts_location.svg",
	"assets/frontend/ico/contacts_phone.svg": "./app/javascript/assets/frontend/ico/contacts_phone.svg",
	"assets/frontend/ico/contacts_user.svg": "./app/javascript/assets/frontend/ico/contacts_user.svg",
	"assets/frontend/ico/copy.svg": "./app/javascript/assets/frontend/ico/copy.svg",
	"assets/frontend/ico/cross.svg": "./app/javascript/assets/frontend/ico/cross.svg",
	"assets/frontend/ico/cursor.svg": "./app/javascript/assets/frontend/ico/cursor.svg",
	"assets/frontend/ico/dashboard.svg": "./app/javascript/assets/frontend/ico/dashboard.svg",
	"assets/frontend/ico/dashboard_large.svg": "./app/javascript/assets/frontend/ico/dashboard_large.svg",
	"assets/frontend/ico/delete.svg": "./app/javascript/assets/frontend/ico/delete.svg",
	"assets/frontend/ico/dropdown.svg": "./app/javascript/assets/frontend/ico/dropdown.svg",
	"assets/frontend/ico/empty-list.svg": "./app/javascript/assets/frontend/ico/empty-list.svg",
	"assets/frontend/ico/export.svg": "./app/javascript/assets/frontend/ico/export.svg",
	"assets/frontend/ico/eye.svg": "./app/javascript/assets/frontend/ico/eye.svg",
	"assets/frontend/ico/eye_slash.svg": "./app/javascript/assets/frontend/ico/eye_slash.svg",
	"assets/frontend/ico/facebook.svg": "./app/javascript/assets/frontend/ico/facebook.svg",
	"assets/frontend/ico/fly.svg": "./app/javascript/assets/frontend/ico/fly.svg",
	"assets/frontend/ico/footer_fb.svg": "./app/javascript/assets/frontend/ico/footer_fb.svg",
	"assets/frontend/ico/footer_gp.svg": "./app/javascript/assets/frontend/ico/footer_gp.svg",
	"assets/frontend/ico/footer_lang_dd.svg": "./app/javascript/assets/frontend/ico/footer_lang_dd.svg",
	"assets/frontend/ico/footer_tw.svg": "./app/javascript/assets/frontend/ico/footer_tw.svg",
	"assets/frontend/ico/form_mail.svg": "./app/javascript/assets/frontend/ico/form_mail.svg",
	"assets/frontend/ico/form_pass.svg": "./app/javascript/assets/frontend/ico/form_pass.svg",
	"assets/frontend/ico/gift-square.svg": "./app/javascript/assets/frontend/ico/gift-square.svg",
	"assets/frontend/ico/gift.svg": "./app/javascript/assets/frontend/ico/gift.svg",
	"assets/frontend/ico/gmail.svg": "./app/javascript/assets/frontend/ico/gmail.svg",
	"assets/frontend/ico/hourglass.svg": "./app/javascript/assets/frontend/ico/hourglass.svg",
	"assets/frontend/ico/info.svg": "./app/javascript/assets/frontend/ico/info.svg",
	"assets/frontend/ico/info_redesign.svg": "./app/javascript/assets/frontend/ico/info_redesign.svg",
	"assets/frontend/ico/instagram.svg": "./app/javascript/assets/frontend/ico/instagram.svg",
	"assets/frontend/ico/lang.svg": "./app/javascript/assets/frontend/ico/lang.svg",
	"assets/frontend/ico/link_highlight_bottom.svg": "./app/javascript/assets/frontend/ico/link_highlight_bottom.svg",
	"assets/frontend/ico/link_highlight_top.svg": "./app/javascript/assets/frontend/ico/link_highlight_top.svg",
	"assets/frontend/ico/linkedin.svg": "./app/javascript/assets/frontend/ico/linkedin.svg",
	"assets/frontend/ico/list.svg": "./app/javascript/assets/frontend/ico/list.svg",
	"assets/frontend/ico/locale.svg": "./app/javascript/assets/frontend/ico/locale.svg",
	"assets/frontend/ico/location.svg": "./app/javascript/assets/frontend/ico/location.svg",
	"assets/frontend/ico/lock.svg": "./app/javascript/assets/frontend/ico/lock.svg",
	"assets/frontend/ico/logout.svg": "./app/javascript/assets/frontend/ico/logout.svg",
	"assets/frontend/ico/map_search.svg": "./app/javascript/assets/frontend/ico/map_search.svg",
	"assets/frontend/ico/messenger.svg": "./app/javascript/assets/frontend/ico/messenger.svg",
	"assets/frontend/ico/mymir.svg": "./app/javascript/assets/frontend/ico/mymir.svg",
	"assets/frontend/ico/pencil.svg": "./app/javascript/assets/frontend/ico/pencil.svg",
	"assets/frontend/ico/photo.svg": "./app/javascript/assets/frontend/ico/photo.svg",
	"assets/frontend/ico/photo_large.svg": "./app/javascript/assets/frontend/ico/photo_large.svg",
	"assets/frontend/ico/plus.svg": "./app/javascript/assets/frontend/ico/plus.svg",
	"assets/frontend/ico/pomade.svg": "./app/javascript/assets/frontend/ico/pomade.svg",
	"assets/frontend/ico/pomade_left.svg": "./app/javascript/assets/frontend/ico/pomade_left.svg",
	"assets/frontend/ico/popup_close.svg": "./app/javascript/assets/frontend/ico/popup_close.svg",
	"assets/frontend/ico/print.svg": "./app/javascript/assets/frontend/ico/print.svg",
	"assets/frontend/ico/profile_nav_balance.svg": "./app/javascript/assets/frontend/ico/profile_nav_balance.svg",
	"assets/frontend/ico/profile_nav_list.svg": "./app/javascript/assets/frontend/ico/profile_nav_list.svg",
	"assets/frontend/ico/profile_nav_products.svg": "./app/javascript/assets/frontend/ico/profile_nav_products.svg",
	"assets/frontend/ico/profile_nav_settings.svg": "./app/javascript/assets/frontend/ico/profile_nav_settings.svg",
	"assets/frontend/ico/question.svg": "./app/javascript/assets/frontend/ico/question.svg",
	"assets/frontend/ico/refresh.svg": "./app/javascript/assets/frontend/ico/refresh.svg",
	"assets/frontend/ico/reload.svg": "./app/javascript/assets/frontend/ico/reload.svg",
	"assets/frontend/ico/remove.svg": "./app/javascript/assets/frontend/ico/remove.svg",
	"assets/frontend/ico/request-send.svg": "./app/javascript/assets/frontend/ico/request-send.svg",
	"assets/frontend/ico/reviews_arrow.svg": "./app/javascript/assets/frontend/ico/reviews_arrow.svg",
	"assets/frontend/ico/rose.svg": "./app/javascript/assets/frontend/ico/rose.svg",
	"assets/frontend/ico/rose_medium.svg": "./app/javascript/assets/frontend/ico/rose_medium.svg",
	"assets/frontend/ico/rose_small.svg": "./app/javascript/assets/frontend/ico/rose_small.svg",
	"assets/frontend/ico/save.svg": "./app/javascript/assets/frontend/ico/save.svg",
	"assets/frontend/ico/search.svg": "./app/javascript/assets/frontend/ico/search.svg",
	"assets/frontend/ico/settings.svg": "./app/javascript/assets/frontend/ico/settings.svg",
	"assets/frontend/ico/share.svg": "./app/javascript/assets/frontend/ico/share.svg",
	"assets/frontend/ico/sign_in_profile.svg": "./app/javascript/assets/frontend/ico/sign_in_profile.svg",
	"assets/frontend/ico/skype.svg": "./app/javascript/assets/frontend/ico/skype.svg",
	"assets/frontend/ico/star.svg": "./app/javascript/assets/frontend/ico/star.svg",
	"assets/frontend/ico/step_cash.svg": "./app/javascript/assets/frontend/ico/step_cash.svg",
	"assets/frontend/ico/step_gift.svg": "./app/javascript/assets/frontend/ico/step_gift.svg",
	"assets/frontend/ico/step_payment.svg": "./app/javascript/assets/frontend/ico/step_payment.svg",
	"assets/frontend/ico/step_processing.svg": "./app/javascript/assets/frontend/ico/step_processing.svg",
	"assets/frontend/ico/step_transfer.svg": "./app/javascript/assets/frontend/ico/step_transfer.svg",
	"assets/frontend/ico/telegram.svg": "./app/javascript/assets/frontend/ico/telegram.svg",
	"assets/frontend/ico/trash.svg": "./app/javascript/assets/frontend/ico/trash.svg",
	"assets/frontend/ico/twitter.svg": "./app/javascript/assets/frontend/ico/twitter.svg",
	"assets/frontend/ico/upload.svg": "./app/javascript/assets/frontend/ico/upload.svg",
	"assets/frontend/ico/upload_path.svg": "./app/javascript/assets/frontend/ico/upload_path.svg",
	"assets/frontend/ico/upload_redesign.svg": "./app/javascript/assets/frontend/ico/upload_redesign.svg",
	"assets/frontend/ico/usage_star.svg": "./app/javascript/assets/frontend/ico/usage_star.svg",
	"assets/frontend/ico/viber.svg": "./app/javascript/assets/frontend/ico/viber.svg",
	"assets/frontend/ico/vk.svg": "./app/javascript/assets/frontend/ico/vk.svg",
	"assets/frontend/ico/warning.svg": "./app/javascript/assets/frontend/ico/warning.svg",
	"assets/frontend/ico/whatsapp.svg": "./app/javascript/assets/frontend/ico/whatsapp.svg",
	"assets/frontend/ico/yougiver.svg": "./app/javascript/assets/frontend/ico/yougiver.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/assets/frontend/ico sync \\.svg$";